// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__20U4b","unreadBadge":"styles_unreadBadge__6QefC","modalContent":"styles_modalContent__3ETzo","modal":"styles_modal__2F7MF"};